module.exports = __webpack_public_path__ + "img/divinewind.4b9672a9.webp";